module.exports = __webpack_public_path__ + "static/media/img-132.f8551095.jpg";